import {
  collection, query, where, orderBy, startAt, endAt,
  startAfter, endBefore, limit, limitToLast, getDocs, getCountFromServer,
} from "firebase/firestore";
import { db } from "../../../firebase";

export const fetchCpapListPage = async ({
  text, sortBy, statusBy, activityBy, responsibleBy,
  brand = "", model = "", page = 1, itemsPerPage = 100,
  direction, cursor,
}) => {
  const filters = [collection(db, "cpaps")];
  if (statusBy !== "ทั้งหมด") filters.push(where("Status", "==", statusBy));
  if (activityBy !== "ทั้งหมด") filters.push(where("Activity", "==", activityBy));
  if (responsibleBy !== "ทั้งหมด") filters.push(where("ResponsiblePerson", "==", responsibleBy));
  filters.push(orderBy(sortBy));
  if (sortBy !== "LastDueDate") filters.push(startAt(text), endAt(text + "\uf8ff"));

  if (brand || model) {
    // Match the summary's normalized labels before pagination, including Unknown.
    // Reuse existing query indexes for status/search/activity/responsible filters.
    const snapshot = await getDocs(query(...filters));
    const docs = snapshot.docs.filter((doc) => {
      const machine = doc.data();
      return (!brand || (String(machine.Brand || "").trim() || "Unknown") === brand)
        && (!model || (String(machine.Model || "").trim() || "Unknown") === model);
    });
    const offset = (page - 1) * itemsPerPage;
    return { docs: docs.slice(offset, offset + itemsPerPage), count: docs.length };
  }

  const pagination = direction === "next"
    ? [startAfter(cursor), limit(itemsPerPage)]
    : direction === "previous"
      ? [endBefore(cursor), limitToLast(itemsPerPage)]
      : [limit(itemsPerPage)];
  const [snapshot, count] = await Promise.all([
    getDocs(query(...filters, ...pagination)),
    direction ? Promise.resolve(null) : getCountFromServer(query(...filters)),
  ]);
  return { docs: snapshot.docs, count: count ? count.data().count : undefined };
};
